import { publicRequest, request } from '@/utils/request';
// import { getToken } from "@/utils/auth";

// 目录管理--平铺
export function directoryList(params,token) {
  // alert("Stored Token: " + token); // 也可以通过 alert 显示
    return request({
      url: '/system/directory/list',
      method: 'get',
      params,
      // headers: {
      //   Authorization: `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjozMTMsInVzZXJfaWQiOjMwNDUsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI1MTBiZmIxYy1jN2E5LTQ0YTYtOTM1Zi00ZjQ2YTg0MDgyZTkiLCJkZXZpY2VfdHlwZSI6ImFwcC1za2lsbCIsInVzZXJuYW1lIjoiMTM1MTExMTExMTEifQ.RXXzwUMEYSSbS4pUchO3L9EooGm2oE1LWMyyZFPGjWf7smGVy-Pqvfrl9-2K8g13PHVj-yApOeW2JnTZoGvY5Q`
      // }
        headers: {
        Authorization: `Bearer ${token}` // 使用Bearer token格式
      }
    })
  }

// 客服记录表-分页查询
export function customerList(params) {
  return request({
    url: '/system/customer/list',
    method: 'get',
    params,
  })
}

// 客服记录表-新增
export function addCustomer(data) {
  return request({
    url: '/system/customer/add',
    method: 'post',
    data,
  })
}

// 问题表-查询
export function listByIdentify(params) {
  return request({
    url: '/system/problem/listByIdentify',
    method: 'get',
    params,
  })
}